import { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { exportDateRange } from "./departmentExportDates";

export default function DepartmentExportButton({ user, apiUrl, dates }) {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");
    const { t } = useTranslation();
    if (Number(user?.entrepriseId) !== 41) return null;

    const { startDate, endDate, valid } = exportDateRange(dates);
    const download = async () => {
        if (!valid || busy) return;
        setBusy(true);
        setError("");
        try {
            const response = await axios.get(`${apiUrl}webex/calling/exportDepartmentMonthly/${startDate}/${endDate}`, {
                withCredentials: true, responseType: "blob"
            });
            if (!response.data?.size || !String(response.headers["content-type"] || "").includes("text/csv")) {
                throw new Error("Invalid CSV response");
            }
            const url = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            link.download = `webex_departements_${startDate}_${endDate}.csv`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        } catch (failure) {
            let message = t("L'export a echoue. Veuillez reessayer.");
            try {
                const payload = JSON.parse(await failure.response.data.text());
                if (typeof payload.error === "string") message = payload.error;
            } catch { /* Keep the fallback for network failures or non-JSON responses. */ }
            setError(message);
        } finally {
            setBusy(false);
        }
    };

    return <div>
        <button type="button" className="saveCSVWebexCalling" onClick={download} disabled={!valid || busy}
            title={`${startDate} / ${endDate} - ${t("Tous les departements et toutes les personnes, independamment des filtres du tableau.")}`}>
            {t(busy ? "Export en cours..." : "Exporter les departements (CSV)")}
        </button>
        {!valid && <small role="status">{t("Selectionnez une periode de 31 jours maximum dans le calendrier.")}</small>}
        {error && <p role="alert">{error}</p>}
    </div>;
}
